<script setup lang="ts">
import { Check } from "@lucide/vue";
import {
	CheckboxIndicator,
	CheckboxRoot,
	type CheckboxRootEmits,
	type CheckboxRootProps,
	useForwardPropsEmits,
} from "radix-vue";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes, normalizeClass } from "vue";

const props = defineProps<CheckboxRootProps & { class?: HTMLAttributes["class"] }>();
const emits = defineEmits<CheckboxRootEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<CheckboxRoot
		v-bind="forwarded"
		:class="
			twMerge(
				'peer size-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
				normalizeClass(props.class),
			)
		"
	>
		<CheckboxIndicator class="flex size-full items-center justify-center text-current">
			<slot>
				<Check class="size-4" />
			</slot>
		</CheckboxIndicator>
	</CheckboxRoot>
</template>
